import { useField } from 'react-final-form';
import styles from './PnlTable.module.scss';
import { RiErrorWarningFill as ErrorIcon } from 'react-icons/ri';
import { formatNumberWithComma, formatNumberWithCommasAndUnits } from '../../../components/functions/utilities';
import { pnlFormat } from '../../../interfaces/interfaces';



const PnlTable = () => {

    const { input: { value: pnlData } } = useField(`pnlData`, { subscription: { value: true } });
    const { input: { value: unitFormat } } = useField(`unitFormat`, { subscription: { value: true } });

    // console.log('pnlData', pnlData);

    return (
        <>
            {pnlData && pnlData?.length ?
                <div className={styles.pnlTable}>
                    <table>
                        <thead>
                            <tr>
                                <th>

                                </th>
                                <th>
                                    Last 12 Months
                                </th>

                            </tr>

                        </thead>
                        <tbody>
                            {pnlData.map((pnlMetric) => {
                                const isDummyRow = pnlMetric?.isDummyRow;
                                return (
                                    <>
                                        {isDummyRow ?
                                            <tr className={styles.dummyRow}>
                                                <td>
                                                    <div style={{ visibility: "hidden" }} className={styles.valueContainer}>
                                                        dddd
                                                    </div>
                                                </td>
                                                <td >
                                                    <div style={{ visibility: "hidden" }} className={styles.valueContainer}>
                                                        ddd
                                                    </div>
                                                </td>
                                            </tr> : null}
                                        <tr className={`${pnlMetric?.isBorder ? styles.darkenBorder : ''} ${pnlMetric?.isBold ? styles.bold : ''}`}>
                                            <td>
                                                <div className={styles.valueContainer}>
                                                    {pnlMetric.metricName}
                                                </div>
                                            </td>
                                            <td >
                                                <div className={`${styles.valueContainer} ${Number(pnlMetric?.total) < 0 ? styles.negativeValue : ''} `}>
                                                    {pnlMetric.showRedBanner ?
                                                        <div className={styles.iconContainer}>
                                                            <ErrorIcon />
                                                        </div> : <div>
                                                            {pnlMetric?.rowIsAllNull ? '' : pnlMetric?.isPercentage ? `${formatNumberWithComma(pnlMetric?.total, 1)}%` : `₹${formatNumberWithCommasAndUnits(pnlMetric?.total, unitFormat)}${unitFormat == pnlFormat.lakhs ? "L" : "K"}`}
                                                        </div>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                )
                            })}
                        </tbody>

                    </table>

                </div> : null}
        </>

    );
}

export default PnlTable;